import "./styles.css";
export const DashLayoutOpenListCourse = (props) => {
  return (
    <div class="container-dash-list-opencourse">
      <div className="container-login-dash-list-opencourse">
        <div className="wrap-login-dash-list-opencourse">{props.children}</div>
      </div>
    </div>
  );
};
